import { Component, OnDestroy, OnInit } from '@angular/core';
import { GlobalLoaderService } from '../../services/global-loader.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-global-loader',
  standalone: true,
  imports: [],
  templateUrl: './global-loader.component.html',
  styleUrl: './global-loader.component.scss',
})
export class GlobalLoaderComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  constructor(private globalLooaderS: GlobalLoaderService) {}
  ngOnInit(): void {
    this.globalLooaderS
      .getLoader()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.preloader = res;
      });
  }
  preloader: boolean = false;

  ngOnDestroy(): void {
    // Emit a value to trigger `takeUntil` and complete the observable
    this.destroy$.next();
    this.destroy$.complete();
  }
}
